import { render } from "./budget_information_effectView.vue?vue&type=template&id=2e108699"
import script from "./budget_information_effectView.vue?vue&type=script&lang=js"
export * from "./budget_information_effectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__